<template lang="pug">
  v-container(fluid)
    v-row.px-2.px-sm-10.pb-10
      v-col(cols="12")
        h1 {{ translations.title }}
    //- Selector de competiciones
    v-row.px-2.px-sm-10.pb-10
      CompetitionSelectorCollapsable(:info="translations.info" :competitionListAll="competitionListAll" @cardClicked="getMatches" :competitionid="$route.params.competitionid")

    v-row.px-2.px-sm-10.pb-10(v-if="createLoad" align="center" justify="center")
      //- filtros
      v-col(cols="12" lg="4" md="6" sm="12")
        v-text-field(v-model="hometeamfilter"  :label="translations.filter.homeTeam" clearable)
      v-col(cols="12" lg="4" md="6" sm="12")
        v-text-field(v-model="awayteamfilter"  :label="translations.filter.awayTeam" clearable)
      v-col(cols="12" lg="4" md="6" sm="12")
        v-text-field(v-model="matchdayfilter"  :label="translations.filter.matchday" clearable)
      v-col(cols="12" lg="4" md="6" sm="12")
        v-select(v-model="statusfilter"  :items="status" item-text="text" item-value="value" return-object  :label="translations.filter.status" clearable)
      v-col(cols="12").text-right
          v-btn(color="primary" @click="updateMatches" text)
              v-icon mdi-reload
      v-col(cols="12")
        v-data-table(
          :headers="headers"
          :items="datos" 
          :items-per-page="30"
          :custom-sort="customSort"
          :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50], 'itemsPerPageText': $t('api.datatable.rowsperpage')}"
          )
          template(v-slot:body="{ items }")
            tbody
              tr(v-for="item,ind in items"  :key="'item'+ind")
                td {{ item.matchday }}
                td {{ item.hometeam }}
                td {{ item.score }}
                td {{ item.awayteam }}
                td {{ item.startdate }}
                td {{ item.type }}
                td {{ item.status }}
                td(v-if="hasPermission('views.fantasy.matches.loadMatch')")
                  BaseConfirmDialog(@confirm="executeLoadMatch(item._id, 'load')" v-bind="translations.confirmationDialog.reload")
                    template(v-slot="{ on }")
                      v-btn(v-on="on" :disabled="item.bloqued" text).orange--text
                        v-icon mdi-reload

      BaseConfirmDialog(v-if="hasPermission('views.fantasy.matches.bulkMatches')" @confirm="sendBulkForm" v-bind="translations.confirmationDialog.bulk")
        template(v-slot="{ on }")
          v-btn.orange--text(v-on="on" class="mx-2" style="bottom:50px" fab primary right fixed)
            v-icon mdi-upload
</template>

<script>

  import CompetitionSelectorCollapsable from "@/components/selectors/CompetitionSelectorCollapsable";

  export default {
    name: 'FantasyMatchesIndex',
    components: {
      CompetitionSelectorCollapsable,
    },
    data: () => ({
      createLoad: false,
      competitionSelected:'',
      matchdayfilter: '',
      hometeamfilter: '',
      awayteamfilter: '',
      statusfilter: {
        text: '',
        value: ''
      },
    }),
    computed: {
      translations(){
        return this.$t("views.matchesIndex");
      },
      headers(){
        let headers = [
          {
            text: this.translations.tableHeads.matchday,
            value: 'matchday'
          },
          {
            text: this.translations.tableHeads.hometeam,
            value: 'hometeam'
          },
          {
            text: this.translations.tableHeads.score,
            value: 'score'
          },
          {
            text: this.translations.tableHeads.awayteam,
            value: 'awayteam'
          },
          {
            text: this.translations.tableHeads.startdate,
            value: 'startdate'
          },
          {
            text: this.translations.tableHeads.type,
            value: 'type'
          },
          {
            text: this.translations.tableHeads.status,
            value: 'status'
          },
        ];
        if(this.hasPermission('views.fantasy.matches.loadMatch')){
          headers.push(
            {
              text: this.translations.tableHeads.load,
              value: 'load',
              sortable: false
            });
        }
        return headers;
      },
      datos(){
        const vm = this;
        return this.matchesFiltered.map(match =>{
          return {
            _id: match._id,
            matchday: match.matchday,
            hometeam: match.home.name,
            score: `${match.home.score} - ${match.away.score}`,
            awayteam: match.away.name,
            startdate: vm.$moment(match.start).format('DD/MM/YYYY HH:mm'),
            type: match.type,
            status:  match.status != ''? vm.$t('back.status.'+ match.status) : '',
            bloqued: match.bloqued == false || match.bloqued == 'false'? false : true,
          }
        })
      },
      status(){
        return [
          {
            text: this.$t('back.status.pending'),
            value: 'pending'
          },
          {
            text: this.$t('back.status.finished'),
            value: 'finished'
          }
        ];
      },
      matchesList(){
        return this.$store.state.fantasy.matches;
      },
      matchesFiltered(){
        const vm = this;

        const filters = {
          matchday: {
            function: vm.filterMatchday,
            condition: vm.matchdayfilter
          },
          hometeam: {
            function: vm.filterHomeTeam,
            condition: vm.hometeamfilter
          },
          awayteam: {
            function: vm.filterAwayTeam,
            condition: vm.awayteamfilter
          },
          status: {
            function: vm.filterStatus,
            condition: vm.statusfilter
          }
        };

        return vm.matchesList.filter(player => {
          const filterKeys = Object.keys(filters);
          return filterKeys.every(key => {
            return filters[key]['function'](player, filters[key]['condition']);
          });
        });
      },
      competitionListAll() {
        return this.$store.state.fantasy.competitions;
      },
    },
    created(){
      this.createLoad = false;
      this.$store.dispatch('getCompetitions');
    },
    methods:{
      dateFormat(dateString){
        const date = new Date(dateString);
        return date.getFullYear() + '-' + date.getMonth() +'-'+ date.getDate();
      },
      findCompetition(idCompetition){
        return this.$store.state.fantasy.competitions.find(item =>{ return item._id == idCompetition });
      },
      filterMatchday(item, condition){
        return condition == undefined || condition == '' || item.matchday == condition;
      },
      filterHomeTeam(item, condition){
        return condition == undefined || condition == '' || item.home.name.toLowerCase().indexOf(condition.toLowerCase()) != -1 || item.home.name.toLowerCase().indexOf(condition.toLowerCase()) != -1;
      },
      filterAwayTeam(item, condition){
            return condition == undefined || condition == '' || item.away.name.toLowerCase().indexOf(condition.toLowerCase()) != -1 || item.away.name.toLowerCase().indexOf(condition.toLowerCase()) != -1;
      },
      filterStatus(item, condition){
        return condition == undefined || condition.value == '' || item.status == condition.value;
      },
      getMatches(competitionId){
        if(this.createLoad == false){
          this.createLoad = true;
        }
        this.competitionSelected = competitionId;
        this.$store.dispatch('getMatches', competitionId);
      },
      sendBulkForm(){
        let data = {
          action:'match',
          competition: this.competitionSelected,
        };

        this.$store.dispatch('actionBulkLoad',data);
      },
      customSort(list, index, isDesc){
        list.sort((a, b) => {
          if (index[0]=='startdate') {
            if (!isDesc[0]) {
                return this.getDateCustom(b[index]) - this.getDateCustom(a[index]);
            } else {
                return this.getDateCustom(a[index]) - this.getDateCustom(b[index]);
            }
          }
          if (index[0]=='matchday') {
            if (!isDesc[0]) {
                return b[index] - a[index];
            } else {
                return a[index] - b[index];
            }
          }
          else {
            if(typeof a[index] !== 'undefined'){ //Para el resto
              if (!isDesc[0]) {
                 return a[index].toLowerCase().localeCompare(b[index].toLowerCase());
              }
              else {
                  return b[index].toLowerCase().localeCompare(a[index].toLowerCase());
              }
            }
          }
        });
        return list;
      },
      getDateCustom(str){
        const dateArray = str.replace(' ', '/').replace(':', '/').split('/');
        return new Date(dateArray[2], dateArray[1] - 1, dateArray[0], dateArray[3], dateArray[4]).getTime();
      },
      executeLoadMatch(matchId, type){
        this.$store.dispatch('actionMatches',{matchId:matchId,type:type});
      },
      updateMatches(){
          let competitionId = this.competitionSelected;
          this.$store.dispatch('getMatches', competitionId);
      }
    }
  }
</script>

<style lang="sass">
</style>